export const LOGS_CONST = `
##      ## #### ########  ########     ########  ######## ##     ##  #######  
##  ##  ##  ##  ##     ## ##     ##    ##     ## ##       ###   ### ##     ## 
##  ##  ##  ##  ##     ## ##     ##    ##     ## ##       #### #### ##     ## 
##  ##  ##  ##  ########  ##     ##    ##     ## ######   ## ### ## ##     ## 
##  ##  ##  ##  ##   ##   ##     ##    ##     ## ##       ##     ## ##     ## 
##  ##  ##  ##  ##    ##  ##     ##    ##     ## ##       ##     ## ##     ## 
 ###  ###  #### ##     ## ########     ########  ######## ##     ##  #######  
`;

// https://patorjk.com/ BANNER3
